import { PhoneIncoming, PhoneOutgoing } from 'lucide-react'
import { DirectionPill } from '@/components/DirectionPill'

interface CallTypeBadgeProps {
  type: string | null | undefined
}

/** Inbound/Outbound pill shared by the Calls table and the detail sheet. */
export function CallTypeBadge({ type }: CallTypeBadgeProps) {
  if (!type) return null

  const normalized = type.toLowerCase()

  if (normalized === 'inbound' || normalized === 'outbound') {
    return (
      <DirectionPill
        direction={normalized}
        icon={normalized === 'inbound' ? PhoneIncoming : PhoneOutgoing}
        label={type}
      />
    )
  }

  return <div className="capitalize">{type}</div>
}
